/**
 */

define('directives/myservices/callbackUrl/callbackUrlForAccount.directives',['app', 'mainCons'], function (app, mainCons) {
    app.directive('callbackUrlForAccount', [function () {
        return {
            restrict: 'E',
            replace: true,
            require: "?ngModel",
            scope: {
                model: "=",
                packageForm: "="
            },
            templateUrl: '../refactor/directives/myservices/callbackUrl/callbackUrlForAccount.template.html',
            link: function ($scope) {
                $scope.regexp = mainCons.servicesConstant.regexp;
                $scope.initData = initData;
                $scope.model.isShowAll = true;
                $scope.validOauthRedirectUri = validOauthRedirectUri();
                $scope.checkRepeat = checkRepeat;

                function checkRepeat() {
                    for (var n = 0; n < $scope.model.selected.callbackUrlList.length; n++) {
                        if (!$scope.packageForm["callbackUrl" + n]) continue;
                        $scope.packageForm["callbackUrl" + n].$setValidity("repeat", true);
                    }
                    for (var i = 0; i < $scope.model.selected.callbackUrlList.length; i++) {
                        for (var j = i + 1; j < $scope.model.selected.callbackUrlList.length; j++) {
                            if (!$scope.packageForm["callbackUrl" + i] || !$scope.packageForm["callbackUrl" + j]) continue;
                            if ($scope.model.selected.callbackUrlList[i] && $scope.model.selected.callbackUrlList[i] == $scope.model.selected.callbackUrlList[j]) {
                                if (!$scope.packageForm["callbackUrl" + i].$error.pattern) {
                                    $scope.packageForm["callbackUrl" + i].$setValidity("repeat", false);
                                }
                                if (!$scope.packageForm["callbackUrl" + j].$error.pattern) {
                                    $scope.packageForm["callbackUrl" + j].$setValidity("repeat", false);
                                }
                            }
                        }
                    }

                }

                function initData() {
                    if (!$scope.model.selected.callbackUrlList) {
                        $scope.model.selected.callbackUrlList = ['']
                    }
                    if ($scope.model.selected.callbackUrlList.length > 5) {
                        $scope.model.isShowAll = false;
                    }
                }

                $scope.delURLList = function (index) {
                    $scope.model.selected.callbackUrlList.splice(index, 1);
                };
                $scope.addURLList = function () {
                    if ($scope.model.selected.callbackUrlList.length < 50) {
                        $scope.model.selected.callbackUrlList.push("");
                    }
                };

                function validOauthRedirectUri() {
                    var regexp = new RegExp($scope.regexp.oauthRedirectUri);
                    return {
                        test: function (value) {
                            //验证是否以http或https开头
                            var regExpErrorP = "，不能包含字符'?'";
                            var regExpErrorY = "回调地址不能包含字符'?'";
                            var regExpErrorT = "回调地址不合法，请重新输入。";
                            var regExpErrorX = "回调地址应该以http://或者https://开头";
                            if (!regexp.test(value)) {
                                $scope.validCallbackUrlText = regExpErrorT;
                                if (value.substring(0, 8) != 'https://' && value.substring(0, 7) != 'http://') {
                                    $scope.validCallbackUrlText = regExpErrorX;
                                }
                                if (value.indexOf('?') > -1) {
                                    if ($scope.validCallbackUrlText != regExpErrorT) {
                                        $scope.validCallbackUrlText += regExpErrorP;
                                    } else {
                                        $scope.validCallbackUrlText = regExpErrorY;
                                    }
                                }
                                return false;
                            } else {
                                if (value.indexOf('?') > -1) {
                                    $scope.validCallbackUrlText = regExpErrorY;
                                    return false;
                                }
                            }
                            return regexp.test(value) && value.substring(value.length - 1) != '\\';
                        }
                    }
                }
            }
        }
    }]);
});

